/**
 * Color Pattern Resolver
 * Applies colors from the global shopifyColorPatterns object to swatches
 * This solves the 50-item metaobject limit issue
 */
(function() {
  'use strict';
  
  // Wait for color patterns to be loaded
  function waitForColorPatterns(callback) {
    if (window.shopifyColorPatterns) {
      callback();
    } else {
      setTimeout(() => waitForColorPatterns(callback), 100);
    }
  }
  
  // Apply color to a swatch element
  function applyColorToSwatch(swatchElement, colorData) {
    if (!swatchElement || !colorData) return false;
    
    // Apply color or image based on data
    let backgroundValue = null;
    
    if (colorData.image) {
      backgroundValue = `url(${colorData.image})`;
    } else if (colorData.color) {
      backgroundValue = colorData.color;
    }
    
    if (backgroundValue) {
      swatchElement.style.setProperty('--swatch-background', backgroundValue);
      return true;
    }
    
    return false;
  }
  
  // Process all swatches on the page
  function processSwatches() {
    const swatchElements = document.querySelectorAll('.swatch');
    let processedCount = 0;
    let appliedCount = 0;
    
    swatchElements.forEach(swatch => {
      // Check if swatch already has a background
      const currentBackground = swatch.style.getPropertyValue('--swatch-background');
      if (currentBackground && currentBackground !== 'none') {
        return; // Skip swatches that already have colors
      }
      
      // Find the parent label to get color information
      const label = swatch.closest('label');
      if (!label) return;
      
      // Try to find the color value from the input
      const input = label.querySelector('input[type="radio"]');
      if (!input) return;
      
      const colorValue = input.value;
      if (!colorValue) return;
      
      // Convert color value to handle format (lowercase, hyphenated)
      const colorHandle = colorValue.toLowerCase().replace(/\s+/g, '-');
      
      processedCount++;
      
      // Look up color in global patterns
      const colorData = window.shopifyColorPatterns[colorHandle];
      if (colorData) {
        if (applyColorToSwatch(swatch, colorData)) {
          appliedCount++;
          // Also add a data attribute to mark it as resolved
          swatch.setAttribute('data-color-resolved', 'true');
        }
      } else {
        // Mark as not found for debugging
        swatch.setAttribute('data-color-resolved', 'not-found');
        swatch.setAttribute('data-color-handle', colorHandle);
      }
    });
    
    if (processedCount > 0) {
      console.log(`[Color Resolver] Processed ${processedCount} swatches, applied colors to ${appliedCount}`);
    }
  }
  
  // Process swatches for a specific container
  function processSwatchesInContainer(container) {
    if (!container) return;
    
    const swatches = container.querySelectorAll('.swatch:not([data-color-resolved])');
    swatches.forEach(swatch => {
      const label = swatch.closest('label');
      if (!label) return;
      
      const input = label.querySelector('input[type="radio"]');
      if (!input) return;
      
      const colorHandle = input.value.toLowerCase().replace(/\s+/g, '-');
      const colorData = window.shopifyColorPatterns[colorHandle];
      
      if (colorData) {
        applyColorToSwatch(swatch, colorData);
        swatch.setAttribute('data-color-resolved', 'true');
      }
    });
  }
  
  // Initialize the color resolver
  function init() {
    console.log('[Color Resolver] Initializing...');
    
    // Process existing swatches
    processSwatches();
    
    // Watch for dynamic content
    const observer = new MutationObserver((mutations) => {
      mutations.forEach(mutation => {
        // Process new nodes
        mutation.addedNodes.forEach(node => {
          if (node.nodeType === Node.ELEMENT_NODE) {
            // Check if it's a swatch or contains swatches
            if (node.classList && node.classList.contains('swatch')) {
              processSwatchesInContainer(node.parentElement);
            } else if (node.querySelector) {
              const swatches = node.querySelectorAll('.swatch');
              if (swatches.length > 0) {
                processSwatchesInContainer(node);
              }
            }
          }
        });
      });
    });
    
    // Observe the entire document for changes
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
    
    // Also process when variant pickers are updated
    document.addEventListener('variant:selected', () => {
      setTimeout(processSwatches, 100);
    });
    
    // Process when overflow lists are expanded
    document.addEventListener('overflow-list:expanded', () => {
      setTimeout(processSwatches, 100);
    });
    
    console.log('[Color Resolver] Ready - monitoring for swatches');
  }
  
  // Wait for DOM and color patterns to be ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      waitForColorPatterns(init);
    });
  } else {
    waitForColorPatterns(init);
  }
  
  // Expose for debugging
  window.colorPatternResolver = {
    processSwatches,
    processSwatchesInContainer,
    patterns: () => window.shopifyColorPatterns
  };
})();